
import { createAction } from 'redux-actions'
import { sourceSetupPage, warehouseSetupPage } from 'analytics'
import { getActiveWorkspace } from 'selectors'

export const SHOW_SOURCE_SETUP = 'SHOW_SOURCE_SETUP'
export const HIDE_SOURCE_SETUP = 'HIDE_SOURCE_SETUP'
export const SHOW_WAREHOUSE_SETUP = 'SHOW_WAREHOUSE_SETUP'
export const HIDE_WAREHOUSE_SETUP = 'HIDE_WAREHOUSE_SETUP'

const createShowSetupAction = (type, trackPage) => (payload) => (dispatch, getState) => {
  const state = getState()
  const workspace = getActiveWorkspace(state)

  dispatch({ type, payload })
  trackPage(workspace)
}

export const showSourceSetup = createShowSetupAction(SHOW_SOURCE_SETUP, sourceSetupPage)
export const hideSourceSetup = createAction(HIDE_SOURCE_SETUP)

export const showWarehouseSetup = createShowSetupAction(SHOW_WAREHOUSE_SETUP, warehouseSetupPage)
export const hideWarehouseSetup = createAction(HIDE_WAREHOUSE_SETUP)



// WEBPACK FOOTER //
// ./actions/setup.js